/**
 * s3 upload related methods are kept here
 */

import axios, { baseRequestConfig } from './base';

export function initTaskCompletion(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'complete_init',
        values: {
          ...values,
        },
      },
    },
  });
}

export function submitTaskCompletionItem(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'complete_add_bit',
        values,
      },
    },
  });
}

export function completeGetNext(userToken, completionId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'complete_get_next',
        values: {
          completion_id: completionId,
        },
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/completion_questions.js